import { Button } from '@cian/ui-kit';
import { FC, MouseEvent, useCallback } from 'react';
import { useOffer, useTracking, useUser } from '../../hooks';
import { useChatContext } from '../../context';

export const ChatButtonContainer: FC = () => {
  const { chat, user: offerUser } = useOffer();
  const user = useUser();
  const { openChat } = useChatContext();
  const { onChatButtonClick } = useTracking();

  const isChatAvailable = !!chat?.canSendMessage && (!user?.isAuthenticated || offerUser?.cianUserId !== user.id);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onChatButtonClick();
      openChat();
    },
    [onChatButtonClick, openChat],
  );

  if (!isChatAvailable) {
    return null;
  }

  return (
    <Button data-name="ChatButton" fullWidth size="XS" onClick={handleClick} theme="fill_secondary">
      Написать
    </Button>
  );
};
